import AuthenticateService from "@/services/AuthenticateService";

export default {
  state: {
    token: "",
    tokenRenewerPid: null,
    fournisseur: null,
  },
  getters: {},
  mutations: {
    SET_TOKEN(state, payload) {
      state.token = payload;
    },
    SET_TOKEN_RENEWER_PID(state, payload) {
      state.tokenRenewerPid = payload;
    },
    SET_FOURNISSEUR(state, payload) {
      state.fournisseur = payload;
    },
  },
  actions: {
    logout({ commit, dispatch }) {
      dispatch("stopTokenRenewer");
      dispatch("demandeEditee/clear");
      dispatch("demandes/clear");
      commit("SET_FOURNISSEUR", null);
      commit("SET_TOKEN", "");
    },
    setIndentityInfos({ commit, dispatch }, payload) {
      commit("SET_FOURNISSEUR", payload.fournisseur);
      dispatch("setToken", payload.token);
    },
    setToken({ commit, dispatch }, payload) {
      commit("SET_TOKEN", payload);
      dispatch("startTokenRenewer");
    },
    renewToken({ commit, dispatch }) {
      // Obtient un nouveau jeton du serveur, puis redéfinit le jeton du store
      // avec celui-ci.
      AuthenticateService.renew()
        .then((response) => {
          commit("SET_TOKEN", response.data);
        })
        .catch((err) => {
          dispatch("setErreur", err);
        });
    },
    // ititie le générateur de renouvellement des
    // jetons de sécurité
    startTokenRenewer({ dispatch, commit }) {
      let taskRunnerId = setInterval(() => {
        dispatch("renewToken");
      }, 105000);
      commit("SET_TOKEN_RENEWER_PID", taskRunnerId);
    },
    // Arrête le générateur de rafraîchissement des
    // jetons de sécurité
    stopTokenRenewer({ state, commit }) {
      //let pid = state.pid;
      clearInterval(state.tokenRenewerPid);
      commit("SET_TOKEN_RENEWER_PID", null);
    },
  },
};
